<app-navbar></app-navbar>

<ng-particles class="particles" [id]="id" [options]="particlesOptions" > 



</ng-particles>


<div class="   ">

    <router-outlet></router-outlet>
    
</div>


<app-footer></app-footer>

